import React from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import PlaceIcon from '@mui/icons-material/Place';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import type { TFunction } from 'i18next';
import { JOB_PORTAL_KEYS } from '../../../../../i18n/constants/keys';
import type { JobPostingData } from '../../../../../utils/types/JobOpenings';
import type { IJobInfoItem } from '../../interfaces';

export const getJobKeyInfo = (
  t: TFunction,
  jobPostData: JobPostingData | undefined,
  daysLeftText: string,
  startDateText: string,
  endDateText: string,
): IJobInfoItem[] => [
  {
    key: 'department',
    label: t(JOB_PORTAL_KEYS.details.department),
    value: jobPostData?.department || t(JOB_PORTAL_KEYS.details.notSpecified),
    icon: <BusinessIcon fontSize="small" />,
    accent: 'info',
  },
  {
    key: 'location',
    label: t(JOB_PORTAL_KEYS.details.location),
    value: jobPostData?.location || t(JOB_PORTAL_KEYS.details.notSpecified),
    icon: <PlaceIcon fontSize="small" />,
    accent: 'success',
  },
  {
    key: 'workType',
    label: t(JOB_PORTAL_KEYS.details.workType),
    value: jobPostData?.workType || t(JOB_PORTAL_KEYS.details.notSpecified),
    icon: <BusinessCenterIcon fontSize="small" />,
    accent: 'secondary',
  },
  {
    key: 'timeline',
    label: t(JOB_PORTAL_KEYS.details.daysLeft),
    value: `${daysLeftText} - ${startDateText} - ${endDateText}`,
    icon: <AccessTimeIcon fontSize="small" />,
    accent: 'warning',
  },
];
